import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-403b0f8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-step1-detail-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bank-name" }, "开户行名称", -1))
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "开户行名称：", -1))
const _hoisted_5 = {
  key: 0,
  class: "bank-name",
  style: {"margin-top":"28px"}
}
const _hoisted_6 = {
  key: 1,
  class: "item"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "公司主体名称：", -1))
const _hoisted_8 = { style: {"color":"#333"} }

import {
  ref,
  onMounted,
  withDefaults,
  computed,
  watch,
} from "vue";
import { getBankAccountApply } from "@/api/process_bank";
import { PLAINOPTIONS } from "@/const/home";

export default /*#__PURE__*/_defineComponent({
  props: {
    update: { type: Boolean, default: false },
    folwId: { default: 0 }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { update: boolean, folwId: number }




watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      BankAccountApply();
    }
  }
);
const detail = ref({
  PageData: {
    YhBankName: "",
    YhCompanyEntity: "",
    YhDocumentCollection: "",
  },
});
const BankAccountApply = async () => {
  const { Data } = await getBankAccountApply({
    BranchCompanyFlowId: props.folwId,
  });
  if (Data?.PageData) {
    detail.value.PageData = Data.PageData;
    if (detail.value.PageData.YhDocumentCollection) {
      detail.value.PageData.YhDocumentCollection =
        Data.PageData.YhDocumentCollection.split(",");
    }
  }
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};
onMounted(async () => {
  BankAccountApply();
});

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _hoisted_4,
      _createTextVNode(_toDisplayString(detail.value.PageData && detail.value.PageData.YhBankName), 1)
    ]),
    (
        (detail.value.PageData && detail.value.PageData.YhCompanyEntity) ||
        (detail.value.PageData && detail.value.PageData.YhDocumentCollection)
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 开户所需集团资料申请 "))
      : _createCommentVNode("", true),
    (detail.value.PageData && detail.value.PageData.YhCompanyEntity)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          _hoisted_7,
          _createTextVNode(_toDisplayString(detail.value.PageData && detail.value.PageData.YhCompanyEntity), 1)
        ]))
      : _createCommentVNode("", true),
    (detail.value.PageData && detail.value.PageData.YhDocumentCollection)
      ? (_openBlock(), _createBlock(_component_a_checkbox_group, {
          key: 2,
          disabled: "",
          value: detail.value.PageData && detail.value.PageData.YhDocumentCollection
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.PageData &&
        detail.value.PageData.YhDocumentCollection, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_checkbox, {
                key: index,
                class: _normalizeClass(index == 9 ? 'nomargin' : ''),
                value: item.toString()
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(PLAINOPTIONS)[item - 1]), 1)
                ]),
                _: 2
              }, 1032, ["class", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})